import React, { useCallback, useEffect, useState } from 'react';
import apiService from '../../services/apiServices';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import Paper from '@mui/material/Paper';
import EditIcon from '@mui/icons-material/Edit';
import { Link } from 'react-router-dom';
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';
import LinearProgress from '@mui/material/LinearProgress';
import helper from '../../services/helper';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import {
    useParams,
} from 'react-router-dom';

export default function HolidaysHistory(props) {
    const { id: employeeId, filter } = props || {};
    const [holidays, setHolidays] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [loader, setLoader] = useState(true);
    const holidayTypes = [{ id: 0, name: "" }, { id: 1, name: "Vjetor" }, { id: 2, name: "Mjekësor" }, { id: 3, name: "Martesor" }, { id: 4, name: "Pa pagesë" }, { id: 5, name: "Jashtëzakonshëm" }]

    let { id } = useParams();

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const getHolidays = useCallback(() => {
        if (!employeeId) {
            setLoader(false);
            return;
        }
        apiService()
            .query('getEmployeesHolidays', 'id=' + employeeId)
            .then((response) => {
                if (response.success) {
                    setLoader(false);
                    let holidays = response.data || [];
                    if (filter) {
                        holidays = holidays.filter((h) => h.Id !== parseInt(id));
                    }
                    setHolidays(holidays);
                } else {
                    setLoader(false);
                    setHolidays([]);
                }
            });
    }, [employeeId, filter, id]);

    useEffect(() => {
        getHolidays();
    }, [getHolidays]);

    return (
        <> {holidays.length > 0 && <Card style={{ marginTop: 15 }}>
                <CardContent>
                    <Typography variant="h6" gutterBottom>
                        Historiku i pushimeve
                    </Typography>
                    {loader && <LinearProgress sx={{ my: 4 }} />}
                    {!loader && <>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 700 }} aria-label="customized table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Nr</TableCell>
                                        <TableCell>Emri</TableCell>
                                        <TableCell>Lloji i pushimit</TableCell>
                                        <TableCell>Prej</TableCell>
                                        <TableCell>Deri</TableCell>
                                        <TableCell>Statusi</TableCell>
                                        <TableCell>Pershkrimi</TableCell>
                                        <TableCell style={{ width: '50px' }}></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {holidays
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((holiday, index) => (
                                            <TableRow key={holiday.Id}>
                                                <TableCell>{index + 1}</TableCell>
                                                <TableCell>{holiday.EmployeeName}</TableCell>
                                                <TableCell>
                                                    {holidayTypes?.find((h) => h?.id === holiday.HolidayType)?.name || '—'}
                                                </TableCell>
                                                <TableCell>{helper().formatDate(holiday.StartDate)}</TableCell>
                                                <TableCell>{helper().formatDate(holiday.EndDate)}</TableCell>
                                                <TableCell>{holiday.Approve ? "Aprovuar" : "Ne pritje"}</TableCell>
                                                <TableCell>{holiday.Description}</TableCell>
                                                <TableCell>
                                                    <ButtonGroup size="small">
                                                        <Link to={`/holidays/editholiday/${holiday.Id}`}>
                                                            <Button>
                                                                <EditIcon />
                                                            </Button>
                                                        </Link>
                                                    </ButtonGroup>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={[10, 25, 100]}
                            component="div"
                            count={holidays.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </>}
                </CardContent>
            </Card>}
        </>
    );
}
